import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { LockKeyhole, ArrowLeft, Home } from 'lucide-react';

interface NoAccessProps {
  title?: string;
  description?: string;
  backTo?: string;
}

export function NoAccess({
  title = 'No access',
  description = "You don’t have permission to view this page. If you think this is a mistake, contact your admin.",
  backTo = '/merchants',
}: NoAccessProps) {
  return (
    <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center p-6">
      <div className="w-full max-w-2xl">
        <Card className="overflow-hidden border-border/60">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-muted/30" />
            <CardHeader className="relative space-y-2">
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary border border-primary/15">
                    <LockKeyhole className="h-5 w-5" aria-hidden />
                  </div>
                  <div>
                    <CardTitle className="text-2xl">{title}</CardTitle>
                    <CardDescription className="mt-1">{description}</CardDescription>
                  </div>
                </div>
                <div className="hidden sm:flex items-center gap-2 text-xs text-muted-foreground">
                  <span className="inline-flex items-center gap-1 rounded-full border px-2 py-1 bg-background/60">
                    <LockKeyhole className="h-3.5 w-3.5" aria-hidden />
                    Restricted
                  </span>
                </div>
              </div>
            </CardHeader>
          </div>

          <CardContent className="pt-2">
            <div className="grid gap-4 sm:grid-cols-2">
              <Button asChild variant="default" className="gap-2">
                <Link to={backTo}>
                  <Home className="h-4 w-4" />
                  Go to merchants
                </Link>
              </Button>
              <Button
                type="button"
                variant="outline"
                className="gap-2"
                onClick={() => window.history.back()}
              >
                <ArrowLeft className="h-4 w-4" />
                Go back
              </Button>
            </div>

            <div className="mt-6 rounded-lg border bg-muted/20 p-4">
              <p className="text-sm font-medium">Need access?</p>
              <p className="text-sm text-muted-foreground mt-1">
                Ask an admin to grant the correct module permission for your account.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

